/**
 * MaximizeIcon - Maximize-Icon für Windows Window Controls
 *
 * Abgerundetes Rechteck. Ersetzt den alten SVG-Path im WindowControls.
 *
 * @example
 * ```tsx
 * <MaximizeIcon />
 * <MaximizeIcon size={10} />
 * ```
 */
export const MaximizeIcon = ({ size = 10 }: { size?: number }) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 10 10"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M1.47 10C1.28 10 1.09 9.96 0.91 9.88C0.73 9.8 0.58 9.69 0.44 9.56C0.31 9.42 0.2 9.27 0.12 9.09C0.04 8.91 0 8.72 0 8.53V1.47C0 1.28 0.04 1.09 0.12 0.91C0.2 0.73 0.31 0.58 0.44 0.44C0.58 0.31 0.73 0.2 0.91 0.12C1.09 0.04 1.28 0 1.47 0H8.53C8.72 0 8.91 0.04 9.09 0.12C9.27 0.2 9.42 0.31 9.56 0.44C9.69 0.58 9.8 0.73 9.88 0.91C9.96 1.09 10 1.28 10 1.47V8.53C10 8.72 9.96 8.91 9.88 9.09C9.8 9.27 9.69 9.42 9.56 9.56C9.42 9.69 9.27 9.8 9.09 9.88C8.91 9.96 8.72 10 8.53 10H1.47ZM8.5 9C8.57 9 8.63 8.99 8.69 8.96C8.75 8.93 8.81 8.9 8.85 8.85C8.9 8.81 8.93 8.75 8.96 8.7C8.99 8.63 9 8.57 9 8.5V1.5C9 1.43 8.99 1.37 8.96 1.31C8.93 1.25 8.9 1.19 8.85 1.15C8.81 1.1 8.75 1.07 8.69 1.04C8.63 1.01 8.57 1 8.5 1H1.5C1.43 1 1.37 1.01 1.3 1.04C1.25 1.07 1.19 1.1 1.15 1.15C1.1 1.19 1.07 1.25 1.04 1.31C1.01 1.37 1 1.43 1 1.5V8.5C1 8.57 1.01 8.63 1.04 8.7C1.07 8.75 1.1 8.81 1.15 8.85C1.19 8.9 1.25 8.93 1.3 8.96C1.37 8.99 1.43 9 1.5 9H8.5Z"
        fill="currentColor"
        fillRule="evenodd"
      />
    </svg>
  )
}
